import { render, staticRenderFns } from "./BasePrimaryButton.vue?vue&type=template&id=5d9b1253&scoped=true&"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js&"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js&"
import style0 from "./BasePrimaryButton.vue?vue&type=style&index=0&id=5d9b1253&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b1253",
  null
  
)

export default component.exports